export enum LockType {
  FILL_LOCK,
  MODIFY_LOCK,
  SI_LOCK,
  CANCEL_LOCK,
  TRIGGER_LOCK,
  PAUSE_LOCK,
  FILL_NOW_LOCK,
}

export namespace LockType {
  let elements = [
    LockType.FILL_LOCK,
    LockType.MODIFY_LOCK,
    LockType.SI_LOCK,
    LockType.CANCEL_LOCK,
    LockType.TRIGGER_LOCK,
    LockType.PAUSE_LOCK,
    LockType.FILL_NOW_LOCK,
  ];
  let alias = "com.bcdfx.model.LockType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
